import { atom } from 'recoil';

import { FilterModalTypes } from '../../components/FilterModal';
import { BatchTicketAssetsSelection } from '../../pages/BatchTicket/contexts';
import {
  BasketAdvisorListDataItem,
  BasketCustomerOrderItemResume,
  CartSectionStatus,
  CustomerItemDataProps,
  Tags,
} from '../../pages/BatchTicket/utils/types';

import {
  batchTicketRedeemAvailableFilter,
  customerAvailableFilter,
  customerTags,
} from './constants';

export const tagsState = atom<Tags>({
  key: 'tagsState',
  default: customerTags,
});

export const customerCartState = atom<CustomerItemDataProps[]>({
  key: 'customerCartItemsState',
  default: [],
});

export const productsCartState = atom<BatchTicketAssetsSelection>({
  key: 'productsCartState',
  default: {
    fixedIncome: { items: [] },
    coes: { items: [] },
    directTreasury: { items: [] },
    equity: { items: [] },
    funds: { items: [] },
    clubs: { items: [] },
    publicOffers: { items: [] },
    fixedIncomeSell: { items: [] },
    fundsSell: { items: [] },
    equitySell: { items: [] },
    directTreasurySell: { items: [] },
    privatePension: { items: [] },
  },
});

export const customerCartStatusState = atom<CartSectionStatus>({
  key: 'customerCartStatusState',
  default: 'start',
});

export const productsCartStatusState = atom<CartSectionStatus>({
  key: 'productsCartStatusState',
  default: 'locked',
});

export const batchTicketCustomerFilterState = atom<FilterModalTypes.FilterAtom>({
  key: 'batchTicketCustomerFilterState',
  default: {
    availableFilters: customerAvailableFilter,
    selectedFilters: [],
    appliedFilters: [],
  },
});

export const basketAdvisorOrderIdState = atom<string | null>({
  key: 'basketAdvisorOrderIdState',
  default: null,
});

export const basketCustomerOrderResumeState = atom<BasketCustomerOrderItemResume>({
  key: 'basketCustomerOrderResumeState',
  default: {
    data: { all: [], errors: [], valid: [] },
    summary: {} as BasketAdvisorListDataItem,
  },
});

export const batchTicketRedeemFilterState = atom<FilterModalTypes.FilterAtom>({
  key: 'batchTicketRedeemFilterState',
  default: {
    availableFilters: batchTicketRedeemAvailableFilter,
    selectedFilters: [],
    appliedFilters: [],
  },
});
